var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#FAF0E1",
    stroke: "#DEB374"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.018 17.182C10.744 17.182 9.704 16.74 8.885 15.856C8.066 14.972 7.65 13.854 7.65 12.489C7.65 11.124 8.066 9.993 8.885 9.109C9.704 8.225 10.757 7.783 12.018 7.783C14.15 7.783 15.528 9.005 16.009 11.202L14.943 11.527C14.475 9.616 13.526 8.758 12.018 8.758C11.069 8.758 10.302 9.109 9.704 9.798C9.106 10.5 8.807 11.397 8.807 12.489C8.807 13.568 9.106 14.465 9.704 15.154C10.302 15.856 11.069 16.207 12.018 16.207C13.565 16.207 14.553 15.388 14.982 13.75L16.087 13.997C15.528 16.116 14.163 17.182 12.018 17.182Z",
    fill: "#D7A459"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterC);
export default __webpack_public_path__ + "static/media/letterC.76b1b9fd1164d4de300d68f006ee4bf2.svg";
export { ForwardRef as ReactComponent };